import * as React from "react";
import '~/style/common.scss';

import SVGGradient from "~/assets/mainGradient.svg";
import { Footer } from "~/components/atoms/footer";
import { Header } from "~/components/atoms/header";

type Props = {
    children: React.ReactNode[] | React.ReactNode
}

export const PageTemplate = (props: Props) =>
{
    // フェードイン
    React.useEffect( () => {
        const animElements = document.querySelectorAll<HTMLElement>('[data-fadein]');

        animElements.forEach(e => {
            
            const offset = typeof e.dataset.fadein === "string" && e.dataset.fadein != "true"
                ? e.dataset.fadein
                : "-15%";
            
            const observer = new IntersectionObserver(entries => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("anim__fadein--show")
                    }
                });
            },
            {
                root: null,
                rootMargin: `0px 0px ${offset} 0px`
            });
            
            const clientRect = e.getBoundingClientRect() ;
            
            // まだ表示されていない要素のみ監視対象にする
            if(window.scrollY < clientRect.top) {
                e.classList.add("anim__fadein");
                observer.observe(e);
            }
            
        });
    //     // FirstViewで隠しておきたいもの。登場アニメーションはなし。
    //     // 最初非表示だとダメ？
    //     // ちょっと上手くやりたい
    //     const offsetElements = document.querySelectorAll<HTMLElement>('[data-fv-offset]');

    //     offsetElements.forEach(e => {
            
    //         const offset = typeof e.dataset.fvOffset === "string" && e.dataset.fvOffset != "true"
    //             ? e.dataset.fvOffset
    //             : "100%";
            
    //         const observer = new IntersectionObserver(entries => {
    //             entries.forEach((entry) => {
                        
    //                 if(window.scrollY > clientRect.top) {
    //                     entry.target.classList.add("anim__fvOffset--show")
    //                 }
    //                 else {
    //                     entry.target.classList.remove("anim__fvOffset--show")
    //                 }
                        
    //             });
    //         },
    //         {
    //             root: null,
    //             rootMargin: `${offset} 0px`,
    //             threshold: 0
    //         });
            
    //         const clientRect = e.getBoundingClientRect();
    //         e.classList.add("anim__fvOffset");
    //         observer.observe(e);
    //     })
    })
        
    
    return ( <>
        <div className="container">
            <Header />
            <main>
                {props.children}
            </main>
            <SVGGradient style={{width: "0px", height: "0px"}}/>
            <Footer />
        </div>
    </>)
}
